module.exports = __webpack_public_path__ + "img/logo-about.3e4b0df3.png";